export default __webpack_public_path__ + "static/media/28.700fcdda.png";